module.exports = __webpack_public_path__ + "static/media/title.ee5345da.png";